import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

//@material-ui components
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Box, IconButton, Table, TableHead, TableBody, TableCell, TableRow, Typography, Dialog, AppBar, Toolbar, Slide } from '@material-ui/core';
import AssetIcon from 'components/icons/assetIcon';
import CloseIcon from '@material-ui/icons/Close';
//Other components
import InnerAssetRow from 'components/customAssetRow/innerAssetRow';
import Capitalize from 'components/capitalize/capitalize';
import GridContainer from 'components/grid/gridContainer';
import GridItem from "components/grid/gridItem.js";


const useRowStyles = makeStyles((theme) => ({
    tdCenter: {
        margin: "auto",
        textAlign: 'left'
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: "10px",
        flex: 1,
    },
    openCloseIcon: {
        float: "right"
    },
    modalTitleRow: {
        height: "3em",
        backgroundColor: "white",
        alignContent: "center",
        margin: "0px",
        border: "1px solid #e3e3e3"
    },
    titleCell: {
        height: "auto"
    },
    mainRowItem: {
        paddingLeft: "10px",
        paddingRight: "10px",
        backgroundColor: "white",
        //border: "1px solid #2b2c2e"
    },
    rightAlign: {
        'text-align': "right",
        "paddingRight": "16px"
    },
    leftAlign: {
        'text-align': "left",
        "paddingLeft": "0.5rem"
    },
    dialogHeader: {
        color: "#000",
        fontSize: "1.5rem",
        fontWeight: "bold",
        textTransform: "capitalize"
    },
    dialogHeaderCloseButton: {
        marginLeft: "auto",
        color: "#000"
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} timeout={1000} />;
});

export default function CustomAssetRow(props) {
    const { assets, type, showAvailable, ...rest } = props;
    const classes = useRowStyles();
    const { t } = useTranslation();
    const [open, setOpen] = React.useState(false);


    const handleClickOpen = () => {
        if (showAvailable) {
            if (assets.reduce((total, n) => total + (n.equipmentInUse === false ? 1 : 0), 0) > 0)
                setOpen(true);
        }
        else {
            if (assets.reduce((total, n) => total + (n.equipmentInUse === false ? 0 : 1), 0) > 0)
                setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const StyledTableCell = withStyles((theme) => ({
        head: {
            backgroundColor: "rgba(51, 51, 51, 1)",
            color: theme.palette.common.white,
        }
    }))(TableCell);

    return (
        <div {...rest} className={classes.mainRowItem}>
            <GridContainer onClick={handleClickOpen}>
                <GridItem xs={3} sm={3} md={3}>
                    <AssetIcon assetType={type} marginLeft={true} />
                </GridItem>
                <GridItem xs={9} sm={9} md={9} className={classes.tdCenter} >
                    {t(type)} ({showAvailable ? (assets.reduce((total, n) => total + (n.equipmentInUse === false ? 1 : 0), 0)) : (assets.reduce((total, n) => total + (n.equipmentInUse === false ? 0 : 1), 0))})
                </GridItem>
            </GridContainer>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar} style={{ background: '#FFFFFF' }}>
                    <Toolbar variant="dense">
                        <Typography variant="h6" className={classes.dialogHeader}>
                            {showAvailable ?
                                <Trans i18nKey="available" />
                                :
                                <Trans i18nKey="unavailable" />} {t(type)}
                        </Typography>
                        <IconButton className={classes.dialogHeaderCloseButton} onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box>
                    <Table size="small" aria-label="features">
                        <TableHead>
                            <TableRow className={classes.headerRow}>
                                <StyledTableCell className={classes.leftAlign}>
                                    <Capitalize transform={'sentenceCase'}>{t('console')}</Capitalize>                                </StyledTableCell>
                                <StyledTableCell className={classes.leftAlign}>
                                    <Capitalize transform={'sentenceCase'}>{t('features')}</Capitalize>
                                </StyledTableCell>
                                <StyledTableCell className={classes.rightAlign}>
                                    <Capitalize transform={'sentenceCase'}>{t('status')}</Capitalize>                               </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {assets.filter((item) => {
                                var currVal = item.equipmentInUse === undefined ? true : item.equipmentInUse;
                                return !currVal === showAvailable;
                            }).sort((a, b) => {
                                var firstVal = a.equipmentInUse === undefined ? false : a.equipmentInUse;
                                var secondVal = b.equipmentInUse === undefined ? false : b.equipmentInUse;
                                return secondVal - firstVal;
                            }).map((assetRow) => (
                                <InnerAssetRow showAvailable={showAvailable} asset={assetRow} key={assetRow.bodySerial} />
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </Dialog>
        </div>
    );
}


CustomAssetRow.propTypes = {
    assets: PropTypes.arrayOf(PropTypes.shape({
        bodySerial: PropTypes.string.isRequired,
        consoleType: PropTypes.string.isRequired
    })).isRequired,
    type: PropTypes.string.isRequired,
    showAvailable: PropTypes.bool.isRequired,
};